<nz-layout>
  <app-demo-persons-sidebar></app-demo-persons-sidebar>
  <nz-content>
  </nz-content>
</nz-layout>
